import { createContext } from 'react';

import { IMemberInsurance } from '@hooks/useMemberInsurance';

export interface IInsuranceProviderSelection {
	id: string;
	name: string;
}

export interface IInsuranceContext {
	provider?: IInsuranceProviderSelection;
	setProvider: (provider: IInsuranceProviderSelection) => void;
	memberInsurance?: IMemberInsurance[];
	memberInsuranceLoading: boolean;
}

export const InsuranceContext = createContext<IInsuranceContext>({
	provider: undefined,
	setProvider: () => {
		return;
	},
	memberInsurance: undefined,
	memberInsuranceLoading: false,
});
